export default "__VITE_ASSET__BJjDk3Tx__"